import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BillingAccountInformation, MonthlyBill, MonthlyBillItems } from 'src/app/models/billing/BillingAccountInfo';
import { PaymentiframeComponent } from 'src/app/reuseableui/paymentiframe/paymentiframe.component';
import { BillingAccountService } from 'src/app/services/BillingAccount/billing-account.service';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { PaymentService } from 'src/app/services/payment.service';
import { UtilService } from 'src/app/services/util.service';

declare const $: any;

@Component({
  selector: 'app-billdetails',
  templateUrl: './billdetails.component.html',
  styleUrls: ['./billdetails.component.css']
})

export class BilldetailsComponent implements OnInit, OnDestroy {

  billingAccount:BillingAccountInformation = new BillingAccountInformation();
  invoice:MonthlyBill = new MonthlyBill();
  invoiceItems:MonthlyBillItems[] = [];
  billID:number = 0;
  sumTotal:number = 0;
  adjustedAmount: number = 0;
  adjustmentReason: string;
  windowMessageReceivedHandler;
  paymentWindow: Window | null | undefined;
  @ViewChild('payment') paymentComponent!: PaymentiframeComponent;
  loadingPayment = false

  constructor( private billingService :BillingAccountService, private activatedroute : ActivatedRoute, public util: UtilService, private ModuleService: ModulemanagementService,
    private headerInfo: ComponentheaderService, private paymentservice: PaymentService, private toastr: ToastrService, private router: Router) {
    this.headerInfo.setHeaderDisplay('Loading...', [], []);
    this.billID = this.activatedroute.snapshot.queryParams.bid;
    this.windowMessageReceivedHandler = this.windowMessageReceived.bind(this);
  }
  ngOnDestroy(): void {
    window.removeEventListener('message', this.windowMessageReceivedHandler);
  }

  async windowMessageReceived(event: any){
    //debugger;
    if(event.data.type == 'paymentdone'){
      if(event.data.responsecode == '0'){
        this.toastr.success('Payment Successful');
        await this.loadBill();
      }
      else{
         if(isNaN(event.data.responsecode)){
           this.toastr.error(event.data.reason, 'Payment Error', { timeOut: 0, closeButton: true});
         }
         else{
          this.toastr.warning(event.data.reason, 'Payment Processing...', { timeOut: 0, closeButton: true});
         }
      }
      this.paymentComponent.closePaymentWindow();
    }
  }

  async loadBill(){
    const response: any = await this.billingService.getAllMonthlyBillDetail(this.billID).toPromise();

    this.billingAccount = response.billingAccount;
    this.invoice = response.invoice;
    this.invoiceItems = response.invoiceItems;
    this.sumTotal = response.invoiceTotal;
    this.adjustedAmount = response.invoice.adjustmentAmount;
    this.adjustmentReason = response.invoice.adjustmentReason;
    this.headerInfo.setHeaderDisplay(this.invoice.title, [{ displaytext: 'Account Bills', route: 'bills'}, {displaytext: this.invoice.title, route: 'billdetails', params: {bid: this.invoice.invoiceID}}], []);
  }

  async ngOnInit() {
    window.addEventListener('message', this.windowMessageReceivedHandler);
    this.headerInfo.pageLoadingStarted(this);
    try{
      await this.loadBill();
    }
    finally{
      this.headerInfo.pageLoadingDone(this);
    }

  }

  async startPayment(){
    const data: any = await this.paymentservice.initiateSchoolBillPayment(this.invoice.invoiceID).toPromise();
    const url = data?.url;
    if(url === undefined){
      this.router.navigateByUrl('billing/bills');
    }
    else{
      this.openPaymentWindow(url);
    }
  }

  openPaymentWindow(url: any) {
    if (url){
      $('#paymentDialog').modal('show');
      this.paymentComponent.openPaymentWindow(url);
    }
    else{
      this.loadingPayment = false;
    }
  }

}
